import { useRouter } from 'next/router'
import { useEffect, useState } from 'react'

export const useDetermineOnMarketplace = () => {
  const { query } = useRouter()
  const [isMarketplaceDomain, setIsMarketplaceDomain] = useState(false)

  let source = query.utm_source || ''
  // This can be a string[] for some reason
  source =
    typeof source === 'string' ? source.toLowerCase() : source[0].toLowerCase()

  const isMarketplaceUTM = source === 'marketplace'

  useEffect(() => {
    setIsMarketplaceDomain(!window?.location?.hostname?.startsWith('widget.'))
  }, [])

  return isMarketplaceUTM || isMarketplaceDomain
}
